import React from 'react'
import style from './PrimeraParte.module.css'

const PrimeraParte = ({ t }) => {
  return (
    <div className={style.container}>
      <p className={style.titulo}>{t('Products.WhatsappBot.FirstPart.title')}</p>
      <div className={style.divContainer}>
        <div className={style.divIzq}>
          <p className={style.title}>{t('Products.WhatsappBot.FirstPart.title2')}</p>
          <div className={style.separador}></div>
          <ul className={style.ul}>
            <li className={style.li}><span style={{fontWeight:'bold'}}>{t('Products.WhatsappBot.FirstPart.text')}</span>: {t('Products.WhatsappBot.FirstPart.text1')}</li>
            <li className={style.li}><span style={{fontWeight:'bold'}}>{t('Products.WhatsappBot.FirstPart.text2')}</span>: {t('Products.WhatsappBot.FirstPart.text3')}</li>
            <li className={style.li}><span style={{fontWeight:'bold'}}>{t('Products.WhatsappBot.FirstPart.text4')}</span>: {t('Products.WhatsappBot.FirstPart.text5')}</li>
            <li className={style.li}><span style={{fontWeight:'bold'}}>{t('Products.WhatsappBot.FirstPart.text6')}</span>: {t('Products.WhatsappBot.FirstPart.text7')}</li>
            <li className={style.li}><span style={{fontWeight:'bold'}}>{t('Products.WhatsappBot.FirstPart.text8')}</span>: {t('Products.WhatsappBot.FirstPart.text9')}</li>
          </ul>
        </div>
        <div className={style.divDer}>
          <p className={style.title}>{t('Products.WhatsappBot.FirstPart.title3')}</p>
          <div className={style.separador}></div>
          <ul className={style.ul}>
            <li className={style.li}><span style={{fontWeight:'bold'}}>{t('Products.WhatsappBot.FirstPart.text10')}</span>: {t('Products.WhatsappBot.FirstPart.text11')}</li>
            <li className={style.li}><span style={{fontWeight:'bold'}}>{t('Products.WhatsappBot.FirstPart.text12')}</span>: {t('Products.WhatsappBot.FirstPart.text13')}</li>
            <li className={style.li}><span style={{fontWeight:'bold'}}>{t('Products.WhatsappBot.FirstPart.text14')}</span>: {t('Products.WhatsappBot.FirstPart.text15')}</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default PrimeraParte